import React, { Component } from 'react';
var DefaultLayout = require('./common/layout');
import { TableHeaderColumn } from 'react-bootstrap-table';
import DataGrid from './common/dataGrid';
import Chart from './common/chart';
import dateHelper from '../helpers/date.js';
import { Button } from 'react-bootstrap';
import enums from '../config/enums';
import CSVExport from './common/CSVExport';



function dateFormatter(cell, row) {
    return `${dateHelper.fromDBStrToStrWithoutTime(cell)}`;
}

const indexForm = React.createClass({
    render: function () {
        var doctorName = this.props.params.userTypeID != enums.USER_TYPE.DOCTOR ? <TableHeaderColumn dataField='Doctor'>Doctor's Name</TableHeaderColumn> : [];
        
        return (
            <div className='container'>
                <div className='row top-pad'>
                    <div className='col-md-8'>
                        <h3>Patients waiting for advice</h3>
                        <CSVExport 
                                ajaxUrl='/data/getPatientsWaitingForAdvice' 
                                dbKeys={['Patient', 'TimeStamp', 'Doctor', 'Subscribed']} 
                                csvKeys={['Patient name', 'Time Stamp', "Doctor's Name", 'Subscribed since']}
                                fileName={'Patients_waiting_for_advice_' + dateHelper.fromDateToStrWithTimeForFileName(Date.now()) + '.csv'}/>

                        <DataGrid ajaxUrl='/data/getPatientsWaitingForAdvice' ID='grid1'
                        pagination={true}>
                            <TableHeaderColumn dataField='Patient' isKey={true} dataSort={true}>Patient Name</TableHeaderColumn>
                            <TableHeaderColumn
                                dataField='TimeStamp'
                                dataFormat={dateFormatter}
                                dataSort={true}>Time Stamp</TableHeaderColumn>
                            {doctorName}
                            <TableHeaderColumn
                                dataField='Subscribed'
                                dataFormat={dateFormatter}
                                dataSort={true}>Subscribed since</TableHeaderColumn>
                            <TableHeaderColumn dataField='' dataFormat={moreInfoFormatter}></TableHeaderColumn>
                        </DataGrid>
                    </div>
                    <div className='col-md-4'>
                        <h3>Patients</h3>
                        <Chart
                            ChartAjaxUrl='/data/getPatientsBetweenDates'
                            ChartType="line"
                            ID="chart2"
                            containerId="chart2Container"
                            MaxTicks="10" />
                        <hr />
                        <h3>Requests</h3>
                        <Chart
                            ChartAjaxUrl='/data/getRequestsBetweenDates'
                            ChartType="line"
                            ID="chart1"
                            containerId="chart1Container"
                            MaxTicks="10" />
                    </div>
                </div>
            </div>
        )
    }
});

/* More Details */
function moreInfoFormatter(cell, row, enumObject, index) {
    var url = '/patient/' + row.UserID;
    return <a href={url}><Button className='hoverpurple btn btn-default'>More Info</Button></a>
}

module.exports = indexForm;


// WEBPACK FOOTER //
// ./modules/index.jsx